import UserDataOnDemand from '../../../ApolloConnectors/UserData/UserDataConnectorApollo';
import AuthLoginByRouteComponent from './AuthLoginByRouteComponent';

const AuthLoginByRoutePage = () => (
  <UserDataOnDemand>
    {({ ...userDataOnDemand }) => <AuthLoginByRouteComponent {...userDataOnDemand} />}
  </UserDataOnDemand>
);

export default AuthLoginByRoutePage;
